import { Controller } from "@hotwired/stimulus";

// Shared hover/focus tooltip for chart marks. Any descendant with
// [data-viz-tooltip] shows its text near the pointer; keyboard focus shows the
// same content. Text is injected via textContent — never markup.
export default class extends Controller {
  connect() {
    this.tooltip = document.createElement("div");
    this.tooltip.className = "viz-tooltip";
    this.tooltip.setAttribute("role", "status");
    this.tooltip.hidden = true;
    document.body.appendChild(this.tooltip);

    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.element.addEventListener("pointerover", this.show);
    this.element.addEventListener("pointerout", this.hide);
    this.element.addEventListener("focusin", this.show);
    this.element.addEventListener("focusout", this.hide);
  }

  show(event) {
    const mark = event.target.closest("[data-viz-tooltip]");
    if (!mark) return;

    this.tooltip.textContent = mark.dataset.vizTooltip;
    this.tooltip.hidden = false;

    const rect = mark.getBoundingClientRect();
    const tip = this.tooltip.getBoundingClientRect();
    let left = rect.left + rect.width / 2 - tip.width / 2 + window.scrollX;
    left = Math.max(8, Math.min(left, window.scrollX + document.documentElement.clientWidth - tip.width - 8));
    let top = rect.top - tip.height - 8 + window.scrollY;
    if (top < window.scrollY + 4) top = rect.bottom + 8 + window.scrollY;

    this.tooltip.style.left = `${left}px`;
    this.tooltip.style.top = `${top}px`;
  }

  hide(event) {
    if (event.relatedTarget && event.relatedTarget.closest && event.relatedTarget.closest("[data-viz-tooltip]") === event.target.closest("[data-viz-tooltip]")) return;
    this.tooltip.hidden = true;
  }

  disconnect() {
    this.element.removeEventListener("pointerover", this.show);
    this.element.removeEventListener("pointerout", this.hide);
    this.element.removeEventListener("focusin", this.show);
    this.element.removeEventListener("focusout", this.hide);
    this.tooltip.remove();
  }
}
